module.exports = __webpack_public_path__ + "static/5-4706ff597472ce27945890a2bf99a29e.jpg";